import React, { useState } from "react";
import styles from "./UsersDetailsPage.module.css";
import Header from "DreamStream/Shared/Header";
import { OptionsDropdown } from "DreamStream/Shared/OptionsDropdown/OptionsDropdown";
import { useHistory } from "react-router-dom";
import TabBar from "DreamStream/Shared/TabBar";
import UsersDetailsWWGInfoTab from "../UserDetailsWWGInfoTab";
import UsersDetailsDreamstreamTab from "../UsersDetailsDreamstreamTab";
import UsersDetailsGroupsTab from "../UsersDetailsGroupsTab";
import UsersDetailsUplineTab from "../UsersDetailsUplineTab";
import UsersDetailsPluginsTab from "../UsersDetailsPluginsTab";
import UsersDetailsTicketsTab from "../UsersDetailsTicketsTab";

/**
 * Content in all users details page.
 */

export function UsersDetailsPage({ isLinked }) {
  const history = useHistory();

  const [currentPage, changeCurrentPage] = useState("WWG Info");
  const [dropdownOption, setDropdownOption] = useState("");

  const handleRedirect = () => {
    history.push("/dreamstream/users");
  };

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <Header
          title="[Dreamstream Name]"
          onClick={handleRedirect}
          children={
            <div className={styles.optionContainer}>
              <OptionsDropdown
                options={["Sync User"]}
                placeholder={dropdownOption === "" ? "OPTIONS" : dropdownOption}
                openedPlaceholder={"SELECT"}
                onChange={(option) => setDropdownOption(option)}
              />
            </div>
          }
          back={true}
          backTitle="Back to Users"
        />
      </div>
      <div className={styles.tabBarContainer}>
        <TabBar
          activeTitle={currentPage}
          titleList={[
            "WWG Info",
            "Dreamstream",
            "Groups",
            "Upline",
            "Plugins",
            "Tickets",
          ]}
          onChange={changeCurrentPage}
        />
      </div>

      <div className={styles.detailsContainer}>
        {currentPage === "WWG Info" ? (
          <UsersDetailsWWGInfoTab
            isLinked={isLinked ? false : true}
            membershipInfo={{
              status: "Premeir - Cancelled",
              date: "10/2/2022",
              time: "10:59:27AM",
              wwgEmail: "wwgEmail@email.com",
              iboNum: "6227028",
              sponsor: "First and Last Name - 203540",
              platinum: "First and Last Name - 203540",
              emerald: "First and Last Name - 203540",
              diamond: "First and Last Name - 203540",
              pinLevel: "3 - Emerald",
              accountStatus: "1",
              membershipType: "10",
              fullyCancelled: false,
              nextBillDate: "2022-11 02T00:00:00:000z",
              signUpDate: "2011-09-27T18:33:57.207z",
              region: "US",
            }}
          />
        ) : currentPage === "Dreamstream" ? (
          <UsersDetailsDreamstreamTab
            dreamstreamAccess={{
              claimedDateTime: "10/2/2022, 10:59:27AM",
              dsId: "100023307548166",
              invitedDateTime: "10/2/2022, 10:59:27AM",
            }}
            dreamstreamInfo={{
              altEmail: "",
              date: "10/2/2022",
              pinLevel: "3 - Emerald",
              status: "Premier - Cancelled",
              time: "10:59:27AM",
              wwgEmail: "wwgEmail@email.com",
            }}
          />
        ) : currentPage === "Groups" ? (
          <UsersDetailsGroupsTab />
        ) : currentPage === "Upline" ? (
          <UsersDetailsUplineTab />
        ) : currentPage === "Plugins" ? (
          <UsersDetailsPluginsTab />
        ) : (
          <UsersDetailsTicketsTab />
        )}
      </div>
    </div>
  );
}
